import { render, staticRenderFns } from "./pict.vue?vue&type=template&id=819cd78a&scoped=true&"
import script from "./pict.vue?vue&type=script&lang=js&"
export * from "./pict.vue?vue&type=script&lang=js&"
import style0 from "./pict.vue?vue&type=style&index=0&id=819cd78a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819cd78a",
  null
  
)

export default component.exports